
import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDatepickerInputEvent, MatPaginator, MatSort, MatTableDataSource } from "@angular/material";
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from "@angular/material-moment-adapter";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { AppConfig } from "src/app/app.config";
import { MonthClosureService } from "src/app/shared/service/month-closure.service";
import { UserService } from "src/app/shared/service/user.service";
export const MY_FORMATS = {

  parse: {
    dateInput: 'DD-MMM-YYYY',
  },
  display: {
    dateInput: 'DD-MMM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
    selector: 'app-hr-attrition-details',
    templateUrl: './hr-attrition-details.component.html',
    styleUrls: ['./hr-attrition-details.component.css'],
    providers: [
      // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
      // application's root module. We provide it at the component level here, due to limitations of
      // our example generation script.
      {
        provide: DateAdapter,
        useClass: MomentDateAdapter,
        deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
      },

      { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
  })

  export class HRAttritionDetailsComponent implements OnInit {
    attritionDataSource: MatTableDataSource<any>;

    attritiondisplayedColumns: string[] = [
    "EmpCode",
    "NamePerRecords",
    "DesignationName",
    "LocationName",
    "DOJ",
    "ResignationDate",
    "DateOfExit",
    "LeavePayout",
       "LoPs",
       "NoticePeriodDays",
       "JBRecovery",
    "certificationRecovery",
    "salaryAdvanceRecovery",
    "NoticePeriodRecovery",

    "VendorFeeRecovery",

    "GMCExclusion",
    "GPAExclusion",


  ];
  allColumns: string[] = [...this.attritiondisplayedColumns]
  error: string;
  VendorFeeRecovery=1
  currentMonth='';
  currentFY=""
  isFreeze=true;
  attritionFrom:any
  @ViewChild("attritionpaginatorAll", { static: true }) attritionpaginatorAll: MatPaginator;
  @ViewChild("attritionsortAll", { static: true }) attritionsortAll: MatSort;
  HiddenCol: boolean = true;
  constructor(
    private _service: MonthClosureService,
    private config: AppConfig,
    public router: Router,
    private toastr: ToastrService,
    public _userService: UserService,
    private fromAttritionFormBuilder: FormBuilder,
  ) {
    this.attritionFrom = this.fromAttritionFormBuilder.group({
      attritionDetails: this.fromAttritionFormBuilder.array([])
     });
    this.attritionDataSource = new MatTableDataSource();

  }
  ngOnInit() {
    this.toggleColumns();
  }

  toggleColumns(): void {
    this.HiddenCol = !this.HiddenCol;
    if (this.HiddenCol) {
      this.attritiondisplayedColumns = [...this.allColumns];
    } else {
      this.attritiondisplayedColumns = this.allColumns.slice(0, this.allColumns.length - 7);
    }
  }



  getAttritionDetails() {
    this.attritionDataSource.data =[];
    this._service.getAttritionDetails(this.currentMonth).subscribe(
      (data: any[]) => {

        let validationArray = this.fromAttritionFormBuilder.array([]);
        if(data!=null && data.length>0)
        {
          if(this.isFreeze==false)
            {
             this.isFreeze= data[0].IsFreezed
            }
            for(var i=0;i<data.length;i++)
              {
                var today = new Date(data[i].DateOfExit);
                data[i].maxDate = new Date(
                  today.getFullYear(),
                  today.getMonth(),
                  today.getDate()
                );
                if(data[i].DOJ!=null )
                {
                var today = new Date(data[i].DOJ);
                data[i].minDate = new Date(
                  today.getFullYear(),
                  today.getMonth(),
                  today.getDate()
                );
              }
                validationArray.push(this.createAttritionFormGroup(  data[i]))


              }
              this.attritionFrom.setControl('attritionDetails', validationArray);
        this.attritionDataSource.data = data;
        this.attritionDataSource.paginator = this.attritionpaginatorAll;
        this.attritionDataSource.sort = this.attritionsortAll;
        }
      },
      (error) => (this.error = error)
    );
  }
  changed(row){
    row.IsUpdated=true;
      }
  saveAttritionDetails()
  {

    if(this.attritionFrom.invalid)
      {
        this.toastr.warning("Please fill in the required fields");
        this.attritionFrom.markAllAsTouched();
        return;
      }
    var result = this.attritionDataSource.data;

      result[0].LoginUserName=this._userService.getEmail();
      result[0].IsFreezed=this.isFreeze;
    this._service.saveAttritionDetails(result).subscribe(
      (data: any[]) => {
        this.toastr.success("Saved Successfully");
        this.getAttritionDetails();
      },
      (error) => (this.error = error)
    );


  }
  setDate(event:any):any
  {
    const selectedDate = event.value;
    if (selectedDate) {
        const d = new Date(selectedDate)
        return new Date(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes() - d.getTimezoneOffset()).toISOString();
    }
    return "";
  }

  GMCExclusionDateChanged(row,event: MatDatepickerInputEvent<Date>) {
    row.GMCExclusion=this.setDate(event);

}
GPAExclusionDateChanged(row,event: MatDatepickerInputEvent<Date>) {
  row.GPAExclusion=this.setDate(event);

}
  get attritionValidation() : FormArray {
    if(!!this.attritionFrom && !!this.attritionFrom.controls)
    return this.attritionFrom.controls["attritionDetails"] as FormArray
   }
  private createAttritionFormGroup(item: any) : FormGroup{

    return new FormGroup({

      LeavePayout: new FormControl( { value: item.LeavePayout, disabled: this.isFreeze }, [ Validators.pattern(/^(?!0(\.0+$)?$)(0|[1-9]\d{0,2})(\.\d{1,2})?$/)]),
      LoPs: new FormControl( { value: item.LoPs, disabled: this.isFreeze }, [ Validators.pattern(/^(?!0(\.0+$)?$)(0|[1-9]\d{0,2})(\.\d{1,2})?$/)]),
      NoticePeriodDays: new FormControl({ value: item.NoticePeriodDays, disabled: this.isFreeze }, [ Validators.pattern(/^(?!0(\.0+$)?$)(0|[1-9]\d{0,2})(\.\d{1,2})?$/)]),
      NoticePeriodRecovery: new FormControl( { value: item.NoticePeriodRecovery, disabled: this.isFreeze }, [ Validators.pattern(/^(?!0(\.0+$)?$)(0|[1-9]\d{0,8})(\.\d{1,2})?$/)]),

    }
    )
 }
  }
